import { ReportFilter } from 'types';
import { useReportFilters } from '../../../../hooks';

export const useOutstandingResponseFilters = (): ReportFilter[] => {
  const { consultationTypeIds, authorityIds, consultationCategoryIds, consultationStatusIds } =
    useReportFilters();

  return [consultationTypeIds, authorityIds, consultationCategoryIds, consultationStatusIds];
};
